import React from 'react';

const LocationIconHeader = ({
  size = 20,
  fill = '#4F4C4D',
}: {
  size?: number | string;
  fill?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 13.9728C11.4028 12.8467 12.4687 11.7524 13.1979 10.6899C13.9271 9.62743 14.2917 8.61773 14.2917 7.66084C14.2917 6.854 14.1457 6.16602 13.8539 5.59691C13.562 5.0278 13.2003 4.56697 12.7687 4.21443C12.3371 3.8619 11.8722 3.60608 11.374 3.44697C10.8758 3.28787 10.4204 3.20832 10.0076 3.20832C9.59486 3.20832 9.13835 3.28787 8.6381 3.44697C8.13785 3.60608 7.67103 3.8619 7.23765 4.21443C6.80424 4.56697 6.441 5.0278 6.14792 5.59691C5.85483 6.16602 5.70829 6.854 5.70829 7.66084C5.70829 8.61773 6.07287 9.62743 6.80204 10.6899C7.53122 11.7524 8.5972 12.8467 9.99998 13.9728ZM9.99998 15.6602C8.0972 14.2393 6.68401 12.8697 5.76042 11.5513C4.83681 10.2329 4.375 8.94014 4.375 7.67299C4.375 6.71589 4.54193 5.87674 4.87579 5.15553C5.20967 4.43434 5.64806 3.83175 6.19096 3.34778C6.73386 2.86381 7.34028 2.49736 8.01023 2.24843C8.68017 1.9995 9.34342 1.87503 9.99998 1.87503C10.6704 1.87503 11.3371 1.9995 12.0001 2.24843C12.6631 2.49736 13.2661 2.86381 13.809 3.34778C14.3519 3.83175 14.7903 4.43434 15.1242 5.15553C15.458 5.87674 15.625 6.71589 15.625 7.67299C15.625 8.94014 15.1632 10.2329 14.2395 11.5513C13.3159 12.8697 11.9028 14.2393 9.99998 15.6602ZM10.0026 9.04166C10.4196 9.04166 10.7735 8.8955 11.0641 8.6032C11.3547 8.31088 11.5 7.95618 11.5 7.53909C11.5 7.12201 11.3538 6.76818 11.0615 6.47759C10.7692 6.187 10.4145 6.0417 9.9974 6.0417C9.58031 6.0417 9.22648 6.18785 8.9359 6.48016C8.6453 6.77248 8.5 7.12718 8.5 7.54426C8.5 7.96134 8.64615 8.31518 8.93846 8.60576C9.23078 8.89636 9.58548 9.04166 10.0026 9.04166ZM4.375 18.125V16.7917H15.625V18.125H4.375Z"
        fill={fill}
      />
    </svg>
  );
};

export default LocationIconHeader;
